import React, { useState, useEffect } from 'react';
import ListView from './ListView';
import DynamicForm from './DynamicForm';
import { apiService } from '../services/api';

export const ModelManager = ({ schema }) => {
  const [view, setView] = useState('list'); // 'list', 'create', 'edit'
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [notification, setNotification] = useState(null);

  // Reset state when schema changes (user clicks different model in sidebar)
  useEffect(() => {
    setView('list');
    setSelectedDocument(null);
    setNotification(null);
  }, [schema.modelName]);

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  const handleCreate = () => {
    setSelectedDocument(null);
    setView('create');
  };

  const handleEdit = (doc) => {
    setSelectedDocument(doc);
    setView('edit');
  };

  const handleSubmit = async (formData) => {
    try {
      if (view === 'create') {
        await apiService.create(schema.modelName, formData);
        showNotification(`${schema.displayName.slice(0, -1)} created successfully!`);
      } else {
        await apiService.update(schema.modelName, selectedDocument._id, formData);
        showNotification(`${schema.displayName.slice(0, -1)} updated successfully!`);
      }
      setView('list');
      setSelectedDocument(null);
    } catch (error) {
      throw error; // Let the form handle the error display
    }
  };

  const handleCancel = () => {
    setView('list');
    setSelectedDocument(null);
  };

  return (
    <div className="model-manager">
      {notification && (
        <div className={`notification notification-${notification.type}`}>
          {notification.message}
        </div>
      )}

      {view === 'list' && (
        <ListView
          schema={schema}
          onCreate={handleCreate}
          onEdit={handleEdit}
          onRefresh={() => setView('list')}
        />
      )}

      {(view === 'create' || view === 'edit') && (
        <div className="form-view">
          <div className="form-header">
            <h2>
              {view === 'create' ? 'Create New' : 'Edit'} {schema.displayName.slice(0, -1)}
            </h2>
          </div>
          <DynamicForm
            schema={schema}
            initialData={selectedDocument || {}}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
          />
        </div>
      )}
    </div>
  );
};

export default ModelManager;
